module.exports = __webpack_public_path__ + "img/banner3_5_jp.da63789d.png";